import type { FileTriggerProps as AriaFileTriggerProps } from "react-aria-components";
import { FileTrigger as AriaFileTrigger } from "react-aria-components";

import FileIcon from "@/assets/images/icons2/icon--file.svg?component";

import { Button2 } from "../atoms/Button";

type FileTriggerProps = {
  buttonProps?: Parameters<typeof Button2>[0];
  fileStateSetter: (files: File[]) => void;
} & AriaFileTriggerProps;

export function FileTrigger2({ buttonProps, fileStateSetter, ...triggerProps }: FileTriggerProps) {
  return (
    <AriaFileTrigger
      onSelect={(fileList) => {
        const fileArray = fileList ? Array.from(fileList) : [];

        fileStateSetter(fileArray);
      }}
      {...triggerProps}
    >
      <Button2
        classNameChildren="tw:flex tw:gap-1"
        icon={<FileIcon className="tw:-mt-0.5" />}
        {...buttonProps}
      />
    </AriaFileTrigger>
  );
}
